export default () => {
  function initReveal(root) {
    (root || document).querySelectorAll('.js-grad-text:not([data-rv-done])').forEach(rvEl => {
      const html = rvEl.innerHTML;

      const wrap = document.createElement('span');
      wrap.className = 'js-grad-text-wrap';
      wrap.innerHTML = html;

      const final = document.createElement('span');
      final.className = 'js-grad-text-final';
      final.innerHTML = html;
      final.setAttribute('aria-hidden', 'true');

      const grad = document.createElement('span');
      grad.className = 'js-grad-text-grad';
      grad.innerHTML = html;
      grad.setAttribute('aria-hidden', 'true');

      wrap.appendChild(final);
      wrap.appendChild(grad);

      rvEl.innerHTML = '';
      rvEl.appendChild(wrap);
      rvEl.setAttribute('data-rv-done', '1');
    });
  }

  function observeReveal() {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-playing');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });

    document.querySelectorAll('.js-grad-text[data-rv-done]').forEach(el => io.observe(el));
  }

  function start() {
    // .c-title も同じ in-view reveal で扱う
    document.querySelectorAll('.c-title').forEach((el) => {
      el.classList.add('js-grad-text');
    });
    initReveal();
    observeReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
};